import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

export default function getHistory() {
  return history;
}
